export default "__VITE_ASSET__INiaR0UU__"